import { render } from "./RatingGraphBar.vue?vue&type=template&id=b4a76cb6&scoped=true"
import script from "./RatingGraphBar.vue?vue&type=script&lang=js"
export * from "./RatingGraphBar.vue?vue&type=script&lang=js"

import "./RatingGraphBar.vue?vue&type=style&index=0&id=b4a76cb6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a76cb6"]])

export default __exports__